import React from 'react'
import { useTranslation } from 'i18n'

import { ResultSlideNewLayout } from './ResultSlideNewLayout'
import {
  ImageComponent,
  ResultActions,
  VideoComponent,
} from './shared-components'
import { parseVideoIds } from './quiz-utils'

// TODO: pass in a component for relatedBreaks, not data to pass along to <ResultRelatedBreak/>
// TODO: pass in a component for ShareIcons that has links, copy, etc fully-baked before it gets here
export const ResultSlideInner = props => {
  const { t } = useTranslation('personalityQuiz')
  const {
    id,
    backgroundImage, // TODO
    resultLayout = 'ONE_COLUMN',
    videoId,
    title,
    desc,
    link,
    linkTitle,
    image, // TODO
    quizId,
    quizHeadline,
    dropdownButtons,
    onEvent,
    socialShare,
    nextStepButton,
    // puck (BR-5451): rendered media/content nodes + card styling
    puckMedia = null,
    puckContent = null,
    puckCardStyle = undefined,
    puckCardOverlayStyle = undefined,
    puckTitleStyle = undefined,
    puckDescStyle = undefined,
    puckButtons = [],
  } = props

  let videoIDArray = []
  if (videoId) {
    videoIDArray = parseVideoIds(videoId)
  }

  const bgImg = backgroundImage && backgroundImage.id
  const isNewColumnLayout = ['ONE_COLUMN_2024', 'TWO_COLUMN_2024'].includes(
    resultLayout,
  )

  if (isNewColumnLayout) {
    return <ResultSlideNewLayout {...props} />
  }

  return (
    <div
      className={`quiz__item bg-img quiz-end with-shadow`}
      style={puckCardStyle ? { backgroundColor: 'transparent' } : undefined}
    >
      
        <div
          className={`quiz__inner-box quiz__result-box quiz__answer${
            bgImg ? ' bg-image' : ' no-bg-image'
          } orientation-${resultLayout}`}
          style={puckCardStyle}
        >
          {puckCardOverlayStyle && (
            <div aria-hidden style={puckCardOverlayStyle} />
          )}
          <div className="quiz__answer-title">
            <span className={`answer-eyebrow`}>{t('resultsLabel')}</span>
            <h2
              tabIndex={0}
              aria-label={title}
              style={puckTitleStyle}
              dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
          </div>
          <div className="quiz__answer-copy quiz-answer-copy">
            <div
              tabIndex={0}
              aria-label={desc}
              dangerouslySetInnerHTML={{ __html: desc }}
              style={{ marginBottom: '18px', ...(puckDescStyle ?? {}) }}
            ></div>
            {socialShare}
            {(link || (dropdownButtons && dropdownButtons.length > 0)) && (
              <ResultActions
                link={link}
                linkTitle={linkTitle}
                id={id}
                title={title}
                quizId={quizId}
                quizHeadline={quizHeadline}
                onEvent={onEvent}
                dropdownButtons={dropdownButtons}
                shopButtonClassName={props.puckShopButtonClass}
                shopButtonStyle={props.puckShopButtonStyle}
                shopButtonOverlayStyle={props.puckShopButtonOverlayStyle}
              />
            )}
            {puckButtons?.length > 0 && (
              <div
                className="result-multibuttons"
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '15px',
                  width: '100%',
                }}
              >
                {puckButtons.map((b, bi) => (
                  <React.Fragment key={bi}>{b}</React.Fragment>
                ))}
              </div>
            )}
            {puckContent}
          </div>
          {puckMedia ? (
            <div className="quiz__answer-image-container">{puckMedia}</div>
          ) : (
            <>
              <VideoComponent
                videoId={videoId}
                videoIDs={videoIDArray}
                onEvent={onEvent}
                autoPlay={false}
                quizHeadline={quizHeadline}
                quizId={quizId}
              />
              <ImageComponent image={image} />
            </>
          )}
          {nextStepButton}
        </div>
      </div>
    
  )
}

export const ResultSlide = ({
  isGuest,
  result,
  quiz,
  guestPointsEarned,
  relatedBreaks,
  onEvent,
  socialShare,
  skipButton,
  nextStepButton,
}) => {
  return (
    <>
    
      {result ? (
        <ResultSlideInner
          isGuest={isGuest}
          {...result} // what could go wrong
          quizId={quiz.id}
          quizHeadline={quiz.headline}
          guestPointsEarned={guestPointsEarned}
          relatedBreaks={relatedBreaks}
          onEvent={onEvent}
          socialShare={socialShare}
          videoId={result.videoId}
          skipButton={skipButton}
          nextStepButton={nextStepButton}
        />
      ) : (
        <div className={`quiz__item bg-img quiz-end`}>
          <div className="container"></div>
        </div>
      )}
    </>
  )
}

export default ResultSlide
